// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Image/goals.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.goalsmainBox {
  display: flex;
  align-items: start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.goalsmainBox .goalsBox {
  width: calc(16.6666666667% - 0.5rem);
  margin-right: 0.5rem;
  padding: 1.5rem 1rem 4.5rem;
  border-radius: 1rem;
  border: 1px solid #dadce0;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  align-self: stretch;
  color: #000;
  position: relative;
  margin-bottom: 0.75rem;
  background-color: #F2F3F4;
}
.goalsmainBox .goalsBox:nth-child(6n) {
  margin-right: 0;
}
.goalsmainBox .goalsBox:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 60px;
  height: 60px;
  display: inline-block;
  background-size: contain;
  position: absolute;
  right: 15px;
  bottom: 10px;
  opacity: 0.5;
}
.goalsmainBox .goalsBox h4 {
  margin-bottom: 0.75rem;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 0.8rem;
  line-height: 1.4;
  color: #0d6efd;
}
@media only screen and (max-width: 767px) {
  .goalsmainBox .goalsBox {
    width: 100%;
    margin-right: 0;
    padding: 1.5rem 1rem;
  }
  .goalsmainBox .goalsBox:before {
    content: none;
  }
}
.goalsmainBox .goalsBox .goalscampaignmainBox {
  max-height: 130px;
  overflow-y: auto;
}
@media only screen and (max-width: 767px) {
  .goalsmainBox .goalsBox .goalscampaignmainBox {
    height: 80px;
    max-height: 80px;
  }
}
.goalsmainBox .goalsBox .goalscampaignmainBox .goalscampaignBox {
  width: 100%;
  margin-bottom: 0.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.goalsmainBox .goalsBox .goalscampaignmainBox .goalscampaignBox a {
  color: #000;
  display: flex;
  background-color: #B9D9EB;
  padding: 0.25rem 0.5rem;
  font-size: 0.65rem;
  border-radius: 0.25rem;
  text-transform: capitalize;
}
.goalsmainBox .goalsBox .goalscampaignmainBox .goalscampaignBox a.no_goals {
  color: #000 !important;
}
.goalsmainBox .goalsBox .goalscampaignmainBox .goalscampaignBox.nogoalscampaignBox {
  display: flex;
  align-items: center;
}
.goalsmainBox .goalsBox .goalscampaignmainBox .goalscampaignBox.nogoalscampaignBox span {
  font-size: 0.65rem;
  margin-left: 0.25rem;
}
.goalsmainBox .goalsBox .goalscampaignmainBox .goalscampaignBox:last-child {
  margin-bottom: 0;
}
.goalsmainBox .goalscampaignBox p.no_goals {
  color: #000;
  font-weight: 600;
  margin-bottom: 0;
}

.analyticalReportChartAnalysisOne__heading {
  display: flex;
  flex-direction: column;
  margin: 0 0 1rem;
  width: 100%;
}
.analyticalReportChartAnalysisOne__heading h2 {
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.2;
  color: #000000;
  letter-spacing: 1px;
  margin: 4px;
}`, "",{"version":3,"sources":["webpack://./src/styles/campaign.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;AAFJ;AAII;EACI,oCAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAFR;AAIQ;EACI,eAAA;AAFZ;AAKQ;EACI,WAAA;EACA,mDAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAHZ;AAMQ;EACI,sBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAJZ;AAOQ;EAxCJ;IAyCQ,WAAA;IACA,eAAA;IACA,oBAAA;EAJV;EAMU;IACI,aAAA;EAJd;AACF;AAOQ;EAEI,iBAAA;EACA,gBAAA;AANZ;AAQY;EALJ;IAMQ,YAAA;IACA,gBAAA;EALd;AACF;AAOY;EACI,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AALhB;AAOgB;EACI,WAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;AALpB;AAQoB;EACI,sBAAA;AANxB;AAUgB;EACI,aAAA;EACA,mBAAA;AARpB;AAUoB;EAAK,kBAAA;EAAmB,oBAAA;AAN5C;AAUgB;EACI,gBAAA;AARpB;AAmBY;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AAjBhB;;AAwBA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AArBJ;AAuBI;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;AArBR","sourcesContent":["$mobileBig: 767px;\r\n$mobile: 480px;\r\n\r\n.goalsmainBox{\r\n    display: flex;\r\n    align-items: start;\r\n    justify-content: flex-start;\r\n    flex-wrap: wrap;\r\n\r\n    .goalsBox{\r\n        width: calc(100%/6 - 0.5rem);\r\n        margin-right: 0.5rem;\r\n        padding: 1.5rem 1rem 4.5rem;\r\n        border-radius: 1rem;\r\n        border: 1px solid #dadce0;\r\n        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n        align-self: stretch;\r\n        color: #000;\r\n        position: relative;\r\n        margin-bottom: 0.75rem;\r\n        background-color: #F2F3F4;\r\n\r\n        &:nth-child(6n){\r\n            margin-right: 0;\r\n        }\r\n\r\n        &:before{\r\n            content: '';\r\n            background: url(../Image/goals.png);\r\n            width: 60px;\r\n            height: 60px;\r\n            display: inline-block;\r\n            background-size: contain;\r\n            position: absolute;\r\n            right: 15px;\r\n            bottom: 10px;\r\n            opacity: 0.5;\r\n        }\r\n\r\n        h4{\r\n            margin-bottom: 0.75rem;\r\n            -webkit-line-clamp: 1;\r\n            -webkit-box-orient: vertical;\r\n            overflow: hidden;\r\n            font-size: 0.8rem;\r\n            line-height: 1.4;\r\n            color: #0d6efd;\r\n        }\r\n\r\n        @media only screen and (max-width: $mobileBig){\r\n            width: 100%;\r\n            margin-right: 0;\r\n            padding: 1.5rem 1rem;\r\n\r\n            &:before{\r\n                content: none;\r\n            }\r\n        }\r\n\r\n        .goalscampaignmainBox{\r\n            // height: 130px;\r\n            max-height: 130px;\r\n            overflow-y: auto;\r\n\r\n            @media only screen and (max-width: $mobileBig){\r\n                height: 80px;\r\n                max-height: 80px;\r\n            }\r\n\r\n            .goalscampaignBox{\r\n                width: 100%;\r\n                margin-bottom: 0.5rem;\r\n                display: -webkit-box;\r\n                -webkit-line-clamp: 1;\r\n                -webkit-box-orient: vertical;\r\n                overflow: hidden;         \r\n                \r\n                a{\r\n                    color: #000;\r\n                    display: flex;\r\n                    background-color: #B9D9EB;\r\n                    padding: 0.25rem 0.5rem;\r\n                    font-size: 0.65rem;\r\n                    border-radius: 0.25rem;\r\n                    text-transform: capitalize;\r\n                    // text-decoration: underline !important;\r\n\r\n                    &.no_goals{\r\n                        color: #000 !important;\r\n                    }\r\n                }\r\n\r\n                &.nogoalscampaignBox{\r\n                    display: flex;\r\n                    align-items: center;\r\n\r\n                    span{font-size: 0.65rem;margin-left: 0.25rem;}\r\n\r\n                }\r\n\r\n                &:last-child{\r\n                    margin-bottom: 0;\r\n                }\r\n                \r\n            }\r\n        }\r\n    }\r\n\r\n    .goalscampaignBox{\r\n\r\n        p{\r\n\r\n            &.no_goals{\r\n                color: #000;\r\n                font-weight: 600;\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.analyticalReportChartAnalysisOne__heading {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 0 0 1rem;\r\n    width: 100%;\r\n\r\n    h2 {\r\n        font-size: 1.2rem;\r\n        font-weight: 600;\r\n        line-height: 1.2;\r\n        color: #000000;\r\n        letter-spacing: 1px;\r\n        margin: 4px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
